angular.module('component-locations', [])
    .service('Locations', LocalizationService);

LocalizationService.$inject = ['$rootScope', '$filter', 'PortalApi','$translate', 'Storage'];

function LocalizationService($rootScope, $filter, PortalApi, $translate, Storage) {

    var service = {
        location: {id: 1},
        locations: [],
        updateList: function (lang) {

            if(!lang){
                lang = Storage.getItem('lang') ? Storage.getItem('lang') : 'rus';
            }

            if(!location){
                var location = Storage.getItem('location');
                    location = JSON.parse(location);
            }

            PortalApi.searchCity('', lang).then(function (locations) {

                locations = locations.plain();

                var cities = [];
                var regions = [];
                var endIndex;

                //some feature for delete strange locations
                locations = locations.filter(function (location) {
                    return location.parent_id != null && location.id != 1
                });

                var fullList = locations.sort(function(a,b) {
                  return parseFloat(a.parent_id) - parseFloat(b.parent_id);
                });

                for (var i = 0; i < fullList.length; i++) {
                  if (fullList[i].parent_id != 1) {
                    endIndex = i;
                    break;
                  }
                }

                cities = $filter('orderBy')(fullList.slice(endIndex), 'name');
                regions = $filter('orderBy')(fullList.slice(0, endIndex), 'name');

                for (var i = 0; i < regions.length; i++) {
                  regions[i]['kids'] = [];
                  for (var j = 0; j < cities.length; j++) {
                    if (regions[i].id == cities[j].parent_id) {
                      regions[i]['kids'].push(cities[j]);
                    }
                  }
                }
                locations = regions.slice(0);

                // var loca = locations.find(function (loc) {
                //     return loc.name === 'Черкаська область'
                // })
                // console.log('loca', loca);//TODO: Delete
                service.saveLocations(locations);
                service.setActive(location);
                $rootScope.$broadcast('updateLocations');
            });
        },
        init: function () {

            var locations = Storage.getItem('locationsList');
            var location = Storage.getItem('location');
            var lang = Storage.getItem('lang') ? Storage.getItem('lang') : 'rus';

            try {

                if (locations) {
                    locations = JSON.parse(locations);
                }
                if (location) {
                    location = JSON.parse(location);
                }

            } catch (e) {}

            if (Array.isArray(locations) && locations.length) {
                service.locations = locations;
                service.setActive(location);
            } else
            {
               service.updateList(lang);
            }

            $rootScope.$on('changeLang', function () {
                lang = Storage.getItem('lang') ? Storage.getItem('lang') : 'rus';
                service.updateList(lang);

            });
        },
        saveLocations: function (locations) {

            if(service.locations.length == 0){
                locations.map(function (location) {
                    service.locations.push(location);
                });
            }

            Storage.setItem('locationsList', JSON.stringify(locations));
            $rootScope.$broadcast('updateLocations', { location: location });
        },
        setActive: function (location) {
            location = service.initActiveLocation(location);
            Storage.setItem('location', JSON.stringify(location));
            $rootScope.$broadcast('changeLocation', { location: location });
        },
        initActiveLocation: function (location) {

            var loc;
            var parent;

            if (angular.isObject(location)) {
                if (location.parent_id == 1) {
                    for (key in service.locations) {
                      if (service.locations[key].id == location.id) {
                        loc = service.locations[key];
                        break;
                      }
                    };
                } else if (location.id != 1) {
                    for (var i = 0; i < service.locations.length; i++) {
                      if (service.locations[i].id == location.parent_id) {
                        parent = service.locations[i];
                      }
                    }
                    if (Array.isArray(parent.kids) && parent.kids.length) {
                          for (key in parent.kids) {
                            if (parent.kids[key].id == location.id) {
                              loc = parent.kids[key];
                              break;
                            }
                          }
                    }
                }
            }

            service.location = loc ? loc : {id: 1};
            return service.location;
        }
    };

    service.init();
    service.updateList();
    return service;

}

module.exports = 'component-locations';



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/locations/index.js
 ** module id = 110
 ** module chunks = 1
 **/